import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const FavorIcon = ({
  width = '102',
  height = '18'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <IconSvg
      style={{
        width: width,
        height: height
      }}
      viewBox="0 0 136 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 1.99866H61.5987V6.6277H53.1434V10.1716H60.7425V14.6014H53.1434V22.0013H48V1.99866Z"
        fill="#0099E5"
        data-darkreader-inline-fill=""
      ></path>
      <path
        d="M68.6865 1.99866H73.8864L80.9444 21.9984H75.5453L74.3739 18.4188H68.0889L66.9473 21.9984H61.6612L68.6865 1.99866ZM73.0866 14.3279L71.2284 8.50369L69.3703 14.3279H73.0866Z"
        fill="#0099E5"
        data-darkreader-inline-fill=""
      ></path>
      <path
        d="M79.1635 1.99866H84.7618L88.4484 14.3844L92.1052 1.99866H97.5905L90.8476 21.9984H85.9064L79.1635 1.99866Z"
        fill="#0099E5"
        data-darkreader-inline-fill=""
      ></path>
      <path
        d="M98.3694 12.2289V11.8008C98.3694 5.83092 102.285 1.63 107.654 1.63C113.053 1.63 116.909 5.77146 116.909 11.7711V12.1992C116.909 18.1691 112.994 22.37 107.625 22.37C102.228 22.37 98.3694 18.2285 98.3694 12.2289ZM111.656 12.1695V11.8543C111.656 8.39666 110 6.28282 107.627 6.28282C105.255 6.28282 103.629 8.3699 103.629 11.8246V12.1397C103.629 15.5974 105.285 17.7112 107.657 17.7112C110.056 17.7142 111.656 15.6271 111.656 12.1695Z"
        fill="#0099E5"
        data-darkreader-inline-fill=""
      ></path>
      <path
        d="M119.668 1.99866H127.526C130.211 1.99866 132.241 2.71219 133.526 4.02628C134.641 5.14117 135.268 6.68419 135.268 8.71181V8.85451C135.268 11.8246 133.811 13.6827 131.697 14.7412L135.812 21.9984H130.012L126.61 15.7996H124.782V21.9984H119.668V1.99866ZM127.327 11.7146C129.069 11.7146 130.098 10.7156 130.098 9.11614V9.05965C130.098 7.3442 129.013 6.48796 127.297 6.48796H124.782V11.7176H127.327V11.7146Z"
        fill="#0099E5"
        data-darkreader-inline-fill=""
      ></path>
      <path
        d="M37.0768 0.655585C36.7152 0.177522 36.1207 -0.0674866 35.5291 0.0161744C35.2094 0.0609928 28.146 1.08584 23.5655 4.85955C22.7737 4.49801 21.6413 4.13648 20.2729 4.13648C18.9044 4.13648 17.772 4.49801 16.9802 4.85955C12.3998 1.08584 5.33937 0.0609928 5.01966 0.0161744C4.42507 -0.0644987 3.83347 0.177522 3.47193 0.655585C3.3315 0.843822 0 5.31371 0 12.0006C0 18.6875 3.32852 23.1574 3.47193 23.3457C3.78865 23.761 4.27867 24 4.7896 24C4.86429 24 4.94198 23.994 5.01966 23.9851C5.33937 23.9402 12.4028 22.9154 16.9832 19.1417C17.775 19.5032 18.9074 19.8648 20.2759 19.8648C21.6443 19.8648 22.7767 19.5032 23.5685 19.1417C28.149 22.9154 35.2123 23.9402 35.532 23.9851C35.6097 23.997 35.6844 24 35.7621 24C36.276 24 36.766 23.761 37.0798 23.3457C37.2202 23.1574 40.5517 18.6875 40.5517 12.0006C40.5517 5.31371 37.2202 0.843822 37.0768 0.655585ZM3.31059 12.0006C3.31059 7.97891 4.77764 4.88345 5.58736 3.47914C7.61614 3.89147 12.1906 5.05675 15.1038 7.60841V10.3453H9.7256C8.8113 10.3453 8.0703 11.0863 8.0703 12.0006C8.0703 12.9149 8.8113 13.6559 9.7256 13.6559H15.1038V16.3928C12.1966 18.9355 7.61017 20.1068 5.58139 20.5221C4.76868 19.1267 3.31059 16.0522 3.31059 12.0006ZM34.9643 20.5191C32.9326 20.1038 28.3521 18.9325 25.4479 16.3928V13.6559H30.8261C31.7404 13.6559 32.4814 12.9149 32.4814 12.0006C32.4814 11.0863 31.7404 10.3453 30.8261 10.3453H25.4479V7.60841C28.3551 5.06572 32.9415 3.89446 34.9703 3.48213C35.783 4.87748 37.2411 7.94903 37.2411 12.0036C37.2381 16.0193 35.7741 19.1148 34.9643 20.5191Z"
        fill="#0099E5"
        data-darkreader-inline-fill=""
      ></path>
    </IconSvg>
  )
}

export default FavorIcon
